// The LIVE portal domain attached to the stormtech-portal Vercel project
// (verified 2026-07-27). The architecture docs plan reps.stormtechperformance.com
// and an older env file said hub. — neither is attached to any Vercel project.
const DEFAULT_PORTAL_URL = "https://portal.stormtechperformance.com";

/**
 * Base URL of the V2 rep portal. Baked at build time from
 * REACT_APP_V2_PORTAL_URL (.env.production / .env.staging); the fallback
 * keeps production builds correct if the var is ever missing.
 */
export function getV2PortalUrl() {
  const configured = process.env.REACT_APP_V2_PORTAL_URL;
  const base = (configured && configured.trim()) || DEFAULT_PORTAL_URL;
  return base.replace(/\/$/, "");
}

/**
 * Deep link to a project in the V2 rep portal. The portal serves project
 * detail at /inventory/projects/:id (app/reps routes). Falls back to the
 * portal root when the V2 id is unknown.
 */
export function getV2ProjectUrl(v2CollectionId) {
  if (!v2CollectionId) return getV2PortalUrl();
  return `${getV2PortalUrl()}/inventory/projects/${v2CollectionId}`;
}
